import React, { Component } from 'react'

import './style.scss'

class About extends Component {
  
  clickMe (){
    Calendly.initPopupWidget({'url': 'https://calendly.com/deepakmishra/talk'})
  }
  render () {
    return (
      <div className="about">
        <div className="image">
        </div>
        <div className="bio">
          #JavaScript, #Node, #React, #Angular, #jQuery, #HTML5, #CSS Accessibility and more…
        </div>
        <div className="links">
              <a href="mailto:hello@deepakmishra.com" targe="_top">hello@deepakmishra.com</a>
        </div>
      </div>
    )
  }
}

export default About



// WEBPACK FOOTER //
// ./src/components/Sidebar/About/index.js